export default __webpack_public_path__ + "static/media/hero.6878ada5.png";